import Link from 'next/link';
import { Button } from '@/components/shadcn/button';
import { ApiErrorEnum } from '@/types/api';

const COPY = {
  NO_CONTENT: 'All reviews for this trainer are currently complete.',
};

interface Props {
  error?: string;
}

export default function ErrorMessage({ error }: Props) {
  const getErrorCopy = (): string => {
    if (error === ApiErrorEnum.TooManyRequests) {
      return 'Whoa, too many requests!';
    }
    if (error === ApiErrorEnum.NoContent) {
      return COPY.NO_CONTENT;
    }
    return 'Oops, something went wrong!';
  };

  return (
    <div className="my-2 flex grow flex-col items-center justify-center text-lg text-neutral-0">
      <div>{getErrorCopy()}</div>
      {error === ApiErrorEnum.NoContent ? null : (
        <div>Try refreshing the page to continue.</div>
      )}
      {error === ApiErrorEnum.NoContent ? (
        <Link href="/trainers" className="mt-4">
          <Button>Back to Map AI Trainers</Button>
        </Link>
      ) : (
        <Button className="mt-4" onClick={() => window.location.reload()}>
          Refresh
        </Button>
      )}
    </div>
  );
}
